import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { ILevelAnalyzerState } from "./ILevelAnalyzerState";

export function LevelAnalyzer() {
    if (IsMobileDevice()) {
        return null;
    }

    const [state, setState] = React.useState<ILevelAnalyzerState>({
        level: -60,
    });

    React.useEffect(() => {
        UseAnalyzer(state, setState);
    }, []);

    const color = InterpolateColor(state);
    UseCompressor(state.level);

    return (
        <span
            style={{
                color: `rgb(${color[0]}, ${color[1]}, ${color[2]})`,
                minWidth: "30px",
                display: "inline-block",
            }}
        >
            {state.level}
        </span>
    );
}

function UseAnalyzer(
    state: ILevelAnalyzerState,
    setState: React.Dispatch<React.SetStateAction<ILevelAnalyzerState>>
) {
    var analyser = Howler.ctx.createAnalyser();
    Howler.masterGain.connect(analyser);

    // Set the size of the FFT (Fast Fourier Transform) to determine the frequency resolution
    analyser.fftSize = 256; // You can adjust this value based on your requirements

    // Create a Uint8Array to hold the frequency data
    var dataArray = new Uint8Array(analyser.frequencyBinCount);

    // Function to log average decibel level every 500ms
    function setAverageDecibelLevel() {
        // Get the frequency data from the analyser
        analyser.getByteFrequencyData(dataArray);

        // Calculate the average decibel level
        var totalDecibels = 0;
        var count = 0;

        for (var i = 0; i < dataArray.length; i++) {
            // Avoid taking the logarithm of zero or a very small value
            var amplitude = dataArray[i] / 255.0;
            if (amplitude > 0) {
                var decibel = 20 * Math.log10(amplitude);
                totalDecibels += decibel;
                count++;
            }
        }

        // Use a default value of -60 decibels if no valid amplitude values are found
        var averageDecibel =
            count > 0 ? Math.round(totalDecibels / count) : -60;

        setState({ ...state, level: averageDecibel });

        requestAnimationFrame(setAverageDecibelLevel);
    }

    requestAnimationFrame(setAverageDecibelLevel);
}

function InterpolateColor(state: ILevelAnalyzerState) {
    const color1 = [255, 255, 255]; // RGB for white
    const color2 = [255, 74, 8]; // RGB for coral
    const factor = (state.level + 60) / 60; // Normalize level to range 0-1
    const result = color1.slice() as [number, number, number];

    for (let i = 0; i < 3; i++) {
        result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
    }

    return result;
}

function UseCompressor(level: number) {
    const initialVolume = 0.8;
    const compressionThreshold = -15;
    const compressionRatio = 3;

    const differential =
        (100 + compressionThreshold * compressionRatio) / (100 + level);

    let newLevel = differential * initialVolume;
    newLevel = Math.max(0, Math.min(1, newLevel)); // Ensure new volume is between 0 and 1
    // console.log(`[Howler] Level adjuster: ${level} -> ${newLevel.toFixed(2)}`);
    Howler.volume(newLevel);
}
